<div class="row" *ngIf="!baseService.authorized || !baseService.lookupsLoaded">
  <div id="globalLoader" class="global-loader" [ngStyle]="{ 'background-color': sharedService.darkMode ? '#333' : '#fff' }">
        <h1>Loading</h1>
    </div>
</div>
<div class="row" *ngIf="baseService.authorized && baseService.lookupsLoaded">
  <div class="col-sm-12">
    <app-inquiry></app-inquiry>
  </div>
</div>
